const API_BASE = 'https://rab-kd.redesis.net/hook/siscon'

function getToken() {
  return localStorage.getItem('siscon_token') || ''
}
export function setSession({ token, nome, perfil, usuario, paginasPermitidas, empresa, masterAcesso }) {
  localStorage.setItem('siscon_token', token)
  localStorage.setItem('siscon_nome', nome)
  localStorage.setItem('siscon_perfil', perfil)
  localStorage.setItem('siscon_usuario', usuario)
  if (empresa) localStorage.setItem('siscon_empresa', empresa)
  if (masterAcesso) localStorage.setItem('siscon_master_acesso', masterAcesso)
  else localStorage.removeItem('siscon_master_acesso')
  if (paginasPermitidas) localStorage.setItem('siscon_paginas', JSON.stringify(paginasPermitidas))
  else localStorage.removeItem('siscon_paginas')
}
export function getSession() {
  let paginasPermitidas = null
  try {
    const raw = localStorage.getItem('siscon_paginas')
    if (raw) paginasPermitidas = JSON.parse(raw)
  } catch (e) { paginasPermitidas = null }
  return {
    token: localStorage.getItem('siscon_token') || '',
    nome: localStorage.getItem('siscon_nome') || '',
    perfil: localStorage.getItem('siscon_perfil') || '',
    usuario: localStorage.getItem('siscon_usuario') || '',
    empresa: localStorage.getItem('siscon_empresa') || '',
    masterAcesso: localStorage.getItem('siscon_master_acesso') || '',
    paginasPermitidas
  }
}
export function setNomeEmpresaCache(nome) {
  if (nome) localStorage.setItem('siscon_nome_empresa', nome)
}
export function getNomeEmpresaCache() {
  return localStorage.getItem('siscon_nome_empresa') || 'ConGestor'
}
export function clearSession() {
  localStorage.removeItem('siscon_token')
  localStorage.removeItem('siscon_nome')
  localStorage.removeItem('siscon_perfil')
  localStorage.removeItem('siscon_usuario')
  localStorage.removeItem('siscon_empresa')
  localStorage.removeItem('siscon_paginas')
  localStorage.removeItem('siscon_master_acesso')
}

function hexParaRgb(hex) {
  let h = (hex || '').replace('#', '')
  if (h.length === 3) h = h.split('').map(c => c + c).join('')
  const num = parseInt(h, 16) || 0
  return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 }
}
function rgbParaHex({ r, g, b }) {
  return '#' + [r, g, b].map(x => Math.max(0, Math.min(255, Math.round(x))).toString(16).padStart(2, '0')).join('')
}
function misturar(hex, alvo, qtd) {
  const c = hexParaRgb(hex)
  const t = hexParaRgb(alvo)
  return rgbParaHex({ r: c.r + (t.r - c.r) * qtd, g: c.g + (t.g - c.g) * qtd, b: c.b + (t.b - c.b) * qtd })
}
const CORES_TEMA_PROPS = ['--brand-950', '--brand-900', '--brand-800', '--brand-700', '--brand-600', '--brand-500', '--brand-100', '--brand-50']

export function aplicarCorTema(hex) {
  if (!hex || !/^#[0-9a-fA-F]{6}$/.test(hex)) return
  const raiz = document.documentElement.style
  raiz.setProperty('--brand-700', hex)
  raiz.setProperty('--brand-800', misturar(hex, '#000000', 0.18))
  raiz.setProperty('--brand-900', misturar(hex, '#000000', 0.34))
  raiz.setProperty('--brand-950', misturar(hex, '#000000', 0.5))
  raiz.setProperty('--brand-600', misturar(hex, '#ffffff', 0.14))
  raiz.setProperty('--brand-500', misturar(hex, '#ffffff', 0.26))
  raiz.setProperty('--brand-100', misturar(hex, '#ffffff', 0.78))
  raiz.setProperty('--brand-50', misturar(hex, '#ffffff', 0.9))
}
export function limparCorTema() {
  CORES_TEMA_PROPS.forEach(p => document.documentElement.style.removeProperty(p))
}

function normalizarErro(json) {
  if (json && json.sucesso === undefined && typeof json.error === 'string') {
    return { sucesso: false, mensagem: json.error, step: json.step }
  }
  return json
}

let avisandoSessaoExpirada = false
function checarSessaoExpirada(json) {
  if (json && json.sucesso === false && typeof json.mensagem === 'string' && /invalida ou expirada/i.test(json.mensagem)) {
    if (!avisandoSessaoExpirada) {
      avisandoSessaoExpirada = true
      alert('Sua sessão expirou. Faça login novamente para continuar — o que você estava preenchendo pode não ter sido salvo.')
      clearSession()
      window.location.reload()
    }
  }
  return json
}

export async function apiGet(path, params = {}) {
  const qs = new URLSearchParams({ ...params, token: getToken() }).toString()
  const res = await fetch(`${API_BASE}/${path}?${qs}`)
  return checarSessaoExpirada(normalizarErro(await res.json()))
}

export async function apiPost(path, body = {}) {
  const res = await fetch(`${API_BASE}/${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...body, token: getToken() })
  })
  return checarSessaoExpirada(normalizarErro(await res.json()))
}

export async function apiDelete(path, params = {}) {
  const qs = new URLSearchParams({ ...params, token: getToken() }).toString()
  const res = await fetch(`${API_BASE}/${path}?${qs}`, { method: 'DELETE' })
  return checarSessaoExpirada(normalizarErro(await res.json()))
}

// Publico - sem token (usado no login e na landing page de leads)
export async function apiPublicPost(path, body = {}) {
  const res = await fetch(`${API_BASE}/${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
  return res.json()
}

export async function apiPublicGet(path, params = {}) {
  const qs = new URLSearchParams(params).toString()
  const res = await fetch(`${API_BASE}/${path}${qs ? '?' + qs : ''}`)
  return res.json()
}
